export const openModalSavePinType = 'open modal save pin';
export const openModalCreateFolderType = 'open modal create folder';
export const closeModalsType = 'close modals';

export const fetchFoldersType = 'fetch folders';
export const fetchFoldersInitType = 'fetch folders init';
export const fetchFoldersSuccessType = 'fetch folders success';

export const saveFolderType = 'save folder';
export const saveFolderInitType = 'save folder init';
export const saveFolderSuccessType = 'save folder success';

export const savePinInFolderInitType = 'save pin in folder init';
export const savePinInFolderSuccessType = 'save pin in folder success';

export const fetchPinsInitType = 'fetch pins init';
export const fetchPinsSuccessType = 'fetch pins success';